/**
 * /tenants/$slug/workload-issuers — thin route shim. Domain logic lives in
 * features/workload-issuers/.
 */

import { createFileRoute } from "@tanstack/react-router";
import { fetchWorkloadIssuers } from "@/features/workload-issuers/queries";
import { WorkloadIssuersPage } from "@/features/workload-issuers/pages/workload-issuers-page";
import { queryKeys } from "@/lib/query-keys";

export const Route = createFileRoute("/_authed/tenants/$slug/workload-issuers/")({
  loader: ({ context }) =>
    context.queryClient.ensureQueryData({
      queryKey: queryKeys.workloadIssuers.list(context.tenant.id),
      queryFn: () => fetchWorkloadIssuers(context.tenant.id),
    }),
  component: WorkloadIssuersPage,
});
